function capitalizeFirst(text?: string): string {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function stringArrayToNumberArray(stringArray: string[] = []) {
  if (!Array.isArray(stringArray)) {
    return []; // Return an empty array if the input is not an array.
  }

  return stringArray.map((str) => {
    const num = Number(str);
    if (Number.isNaN(num)) {
      return Number.NaN; // Or handle invalid numbers in another way (e.g., throw an error).
    }
    return num;
  });
}

function removeStartFromUnderscore(value: string = "") {
  return value.split("_")[0];
}

function capitalizeEachWord(text?: string, splitCharacter?: string): string {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(splitCharacter ?? " ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export type TextTransformType =
  | "none"
  | "capitalize-first"
  | "capitalize-words";

const transformText = (text: string, transformType: TextTransformType) => {
  switch (transformType) {
    case "capitalize-first":
      return capitalizeFirst(text);
    case "capitalize-words":
      return capitalizeEachWord(text);
    default:
      return text;
  }
};

export {
  capitalizeEachWord,
  capitalizeFirst,
  removeStartFromUnderscore,
  stringArrayToNumberArray,
  transformText
};
